import React from 'react';
import { FAQS } from '../mock';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

export default function FAQ() {
  return (
    <section id="faq" className="relative border-t border-[rgba(201,162,75,0.10)]">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10 py-24">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          <div>
            <p className="text-[10px] tracking-[0.25em] font-mono gold-text">FAQ</p>
            <h2 className="font-display mt-5 text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-[1.05]">
              Questions traders
              <br />
              <span className="gold-text">ask first.</span>
            </h2>
            <p className="mt-6 text-sm text-[#CDBE94] leading-relaxed">
              Direct answers about how Talas handles broker connections, risk enforcement, and the boundary between paper and live execution.
            </p>
          </div>
          <div className="lg:col-span-2">
            <Accordion type="single" collapsible className="w-full">
              {FAQS.map((item) => (
                <AccordionItem key={item.q} value={item.q} className="border-[rgba(201,162,75,0.16)]">
                  <AccordionTrigger className="text-left text-[#F1ECDF] hover:gold-text hover:no-underline">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-sm text-[#CDBE94] leading-relaxed whitespace-pre-line">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
